import {Heading, HStack, Icon, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {CheckoutPaymentSummary} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {ContextTarget, RestrictionActionContext} from '../constants/issueRestrictionAlerts';
import {CorrectiveTaxDocumentCard} from './CorrectiveTaxDocumentCard';

interface CorrectiveTaxDocumentsListProps extends RequiredTestIdProps {
  correctivePayments: CheckoutPaymentSummary[] | Nullish;
  checkoutId: string;
  customerId: string;
  contextTarget?: ContextTarget;
  contextId?: string;
  actionContext?: RestrictionActionContext;
  serviceCaseId?: string;
  serviceOrderId?: string;
  isEditingDisabled?: boolean;
  isCompletingDisabled?: boolean;
}

export function CorrectiveTaxDocumentsList(props: CorrectiveTaxDocumentsListProps) {
  if (isNilOrEmpty(props.correctivePayments)) {
    return null;
  }

  return (
    <VStack spacing={4}>
      <HStack spacing={2}>
        <Icon value="editor/insert_drive_file" />
        <Heading size={4}>{i18n.t('entity.accounting.labels.correctiveTaxDocuments')}</Heading>
      </HStack>
      {props.correctivePayments?.map((payment, index) => (
        <CorrectiveTaxDocumentCard
          key={payment.checkoutPaymentId}
          paymentId={payment.checkoutPaymentId}
          checkoutId={props.checkoutId}
          contextTarget={props.contextTarget}
          contextId={props.contextId}
          actionContext={props.actionContext}
          customerId={props.customerId}
          serviceCaseId={props.serviceCaseId}
          serviceOrderId={props.serviceOrderId}
          isEditingDisabled={props.isEditingDisabled}
          isCompletingDisabled={props.isCompletingDisabled}
          data-testid={suffixTestId(`document-${index}`, props)}
        />
      ))}
    </VStack>
  );
}
